<template>
  <div class="communityHome">
    <communityHeader :router_url='router_url'></communityHeader>

    <div class="focusImg">
      <HomeSwiper></HomeSwiper>
    </div>
    <div class="recommend ">
      <div class="contentWidth clearfix ">
        <div class="hd">推荐圈子</div>
        <div class="bd">
          <div v-if="loading"
               style="height:385px; overflow: hidden;">
            <loading style="margin-top: -100px;"></loading>
          </div>

          <ul class="clearfix"
              v-if="!loading && hotCircles && hotCircles.length != 0">

            <router-link tag="li"
                         class="fc_l bag_position anmition_show"
                         :to="'/circleDetail/'+circle.id"
                         v-for="(circle ,index) in hotCircles"
                         :key="index">

              <div class="boxbg_err error_img">
                <div class="error_img_conter">
                  <img :src="error_login"
                       class="fade_image_out"
                       alt="">
                </div>
              </div>

              <img class="boxbg fade_image_out"
                   :src="circle.cover"
                   style="object-fit: cover;">

              <div class="Headimage"><img :src="circle.logo"></div>
              <div class="name">{{circle.name}}</div>
              <div class="info">{{circle.description}}</div>
              <div class="statistics">
                <span class="state">成员<strong>{{circle.userNum}}</strong></span>
                <span class="middle">|</span>
                <span class="state">作品<strong>{{circle.topicNum}}</strong></span>
              </div>

              <div class="join "
                   v-show="circle.code==0"
                   @click.stop="join(circle.id)">
                <p class="_width">+ 加入</p>

              </div>
              <div class="  hover_join join_dis"
                   v-show="circle.code==1"
                   @click.stop="canceljoin(circle.id)">
                <p class="_width">已加入</p>
                <p class="_width top">取消加入</p>
              </div>

            </router-link>

          </ul>
          <!-- 暂无数据 -->
          <ul class="null_data _width"
              v-if="!loading && hotCircles && hotCircles.length ==0"
              style="margin-top: -100px;">
            <img src="@/assets/image/common/null_data.png"
                 alt="">
            <p>暂无数据...</p>
          </ul>
          <!-- 暂无数据 -->
        </div>
      </div>

    </div>
    <div class="content of_h">
      <div class="contentWidth of_h ">
        <div class="contLeft min_h_768 fc_l mt_20 anmition_show">
          <div class="hd of_h">
            <h3 class="fc_l">发现</h3>
          </div>
          <div class="bd">
            <Dynamic></Dynamic>
          </div>
        </div>
        <div class="contRight fc_r mt_20 anmition_show">
          <Intelligent></Intelligent>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import communityHeader from '@/components/community/common/communityHeader.vue'
import loading from '@/components/loading/loading.vue'
import HomeSwiper from '@/components/swiper/homeSwiper.vue'
import Dynamic from '@/components/community/dynamic/dynamic.vue'
import Intelligent from '@/components/community/intelligent/intelligent.vue'
import { FindBanner, hotCircle, queryUserAll, joinCircle, canceljoinCircle } from '@/utils/api/communityFind.js'

import { Info } from '@/utils/api/login.js'


export default {
  name: 'communityHome',
  data () {
    return {
      loading: true,
      hotCircles: [],
      joinStatte: false,

      defaultImg: 'this.src="' + require('@/assets/image/common/loading.gif') + '"',//未加载
      error_login: require('@/assets/image/common/loading.gif'),
      isLogin_user: {},

      // quanzi: 0,// 圈子出场动画
      // content: 0,//发现和 达人榜的出场动画
    }
  },
  components: {
    communityHeader,
    Dynamic,
    HomeSwiper,
    Intelligent,
    loading
  },

  created () {
    this.is_login();//是否登陆
    this.router_url = this.$route.fullPath;//当前地址url

  },
  methods: {

    // 出场动画
    // handleScroll () {
    //   this.currentScroll = window.pageYOffset //表示当前滚动的位置
    //   // if (this.currentScroll >= this.$refs.testref.offsetTop) { //当前滚动位置到达testref的时候，显示div（100作为调整用）
    //   if (this.$refs.content_ref.offsetTop >= this.currentScroll + 400) { //当前滚动位置到达testref的时候，显示div（100作为调整用）
    //     this.content = 1;//显示动画
    //   }
    // },
    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
        if (this.isLogin == true) {
          this.isLogin_user = data.user
        }
      })
    },


    getfindbanner () {
      return FindBanner()
    },
    // 推荐圈子数据
    hotCircle () {
      this.loading = true;
      hotCircle().then((res) => {
        if (res.data.code == 200) {
          this.hotCircles = res.data.data;
          console.log(this.hotCircles);
          this.loading = false;
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    queryUserAll (data) {
      return queryUserAll(data)
    },
    join (id) {
      // 未登录就去登录
      if (this.isLogin == true) {
        let parmes = {
          circleId: id,
          // headimg: headimg,
          // userId: userid
        };
        joinCircle(parmes).then((res) => {
          if (res.data.data.code == 1) {
            this.$message({
              message: '已经加入圈子，无需重复加入！',
              center: true,
              type: 'warning'
            });
          } else {
            this.$message({
              message: '加入圈子成功！',
              center: true,
              type: 'success'
            });
          };
          this.hotCircle();

        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },
    canceljoin (id) {
      // 未登录就去登录
      if (this.isLogin == true) {
        canceljoinCircle({
          circleId: id,
          // userId: userid
        }).then(res => {
          if (res.data.data.code == 0) {
            this.$message({
              message: '取消加入圈子成功！',
              center: true,
              type: 'success'
            });
          }
          this.hotCircle();
        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    }
  },
  mounted () {
    this.hotCircle()//圈子数据
    //     window.addEventListener("scroll", this.handleScroll);
  },
  // destroyed () {
  //   window.removeEventListener('scroll', this.handleScroll, false)
  // },



}
</script>
<style lang="scss" scoped="scoped">
.hover_join {
  position: relative;
  overflow: hidden;
}
.top {
  position: absolute;
  top: 0.3rem;
  background: #f9fafb !important;
  color: #d3011a !important;
  transition: all 0.3s;
}
.hover_join:hover .top {
  top: 0;
}

.bag_position {
  position: absolute;
  border: 1px solid #d3011a;
}
//div.communityHome{margin-top:71px;}
div.focusImg {
  height: 500px;
  background: #fff;
}
div.recommend {
  height: 425px;
  background: #fff;
  div.contentWidth {
    margin: 0 auto;
  }
  div.hd {
    font-size: 18px;
    font-weight: bold;
    color: #d3011a;
  }
  div.bd {
    margin-top: 30px;
    ul {
      width: 1350px;
      li {
        width: 306px;
        transition: all 0.3s;
        height: 322px;
        border-radius: 3px;
        background: #fff;
        border: 1px #f1f1f1 solid;
        margin-right: 24px;
        cursor: pointer;
        position: relative;

        &:hover {
          box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
        }
        img.boxbg {
          display: block;
          width: 306px;
          height: 128px;
          border-radius: 5px 5px 0 0;
          object-fit: cover;
          position: absolute;
          top: 0;
          z-index: 21;
        }
        div.Headimage {
          display: block;
          width: 100%;
          height: 76px;
          border-radius: 50%;
          margin-top: 75px;
          position: relative;
          z-index: 21;
          img {
            display: block;
            width: 76px;
            height: 76px;
            border-radius: 50%;
            border: 3px rgba(255, 255, 255, 0.5) solid;
            margin: 0 auto;
            background-color: #eee;
          }
        }
        div.name {
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          color: #333;
        }
        div.info {
          height: 30px;
          line-height: 30px;
          text-align: center;
          font-size: 14px;
          color: #999;

          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          box-sizing: border-box;
          word-break: break-all;
          padding: 0 5%;
        }
        div.statistics {
          width: 260px;
          margin: 0 auto;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-top: 1px #eee solid;
          border-bottom: 1px #eee solid;
          span.state {
            padding: 0 10px;
            color: #a2a2a2;
            font-size: 12px;
            strong {
              padding: 0 5px;
              font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei",
                "HanHei SC", "Helvetica Neue", "Open Sans", Arial,
                "Hiragino Sans GB", "微软雅黑", STHeiti, "WenQuanYi Micro Hei",
                SimSun, sans-serif;
            }
          }
        }
        div.join {
          width: 260px;
          margin: 0 auto;
          margin-top: 10px;
          transition: all 0.3s;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: 1px #d3011a solid;
          color: #d5182e;
          border-radius: 3px;
          font-size: 14px;
        }
        div.join:hover {
          background: #d3011a;
          color: #fff;
        }

        div.join_dis {
          width: 260px;
          margin: 0 auto;
          margin-top: 10px;
          transition: all 0.3s;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-radius: 3px;

          border: 1px solid #dcddde;
          background: #f9fafb;
        }
      }
    }
  }
}
.join_dis p {
  color: #333;
  font-size: 14px;
}
div.content {
  background: #f5f5f5;
  div.contentWidth {
    margin: 0 auto;
    padding-bottom: 20px;
  }
  div.contLeft {
    width: 928px;
    div.hd {
      padding: 0 15px;
      border-bottom: 1px #ddd solid;
      background: #fff;
      border-radius: 5px 5px 0 0;
      h3 {
        display: inline-block;
        height: 60px;
        line-height: 60px;
        padding-left: 30px;
        font-size: 18px;
        font-weight: bold;
        color: #d4021b;
        background: url("../../assets/image/community/hdico.png") 0 center
          no-repeat;
      }
      ul {
        li {
          display: inline-block;
          height: 58px;
          line-height: 58px;
          padding: 0 10px;
          font-size: 16px;
          cursor: pointer;
          border-bottom: 2px #fff solid;
          margin-left: 30px;
          color: #888;
          &.on {
            border-color: #d4021b;
            color: #333;
          }
        }
      }
    }
    div.bd {
    }
  }
  div.contRight {
    width: 355px;
    button.publish {
      display: block;
      width: 100%;
      height: 70px;
      line-height: 70px;
      text-align: center;
      border: 0;
      transition: all 1s;
      font-size: 18px;
      color: #fff;
      background-image: linear-gradient(to right, #d7172e, #ff4001);
      &:hover {
        background-image: linear-gradient(to right, #c00, #f00);
      }
    }
  }
}

.boxbg_err {
  width: 306px;
  height: 128px;
  position: absolute;
  top: 0;
  z-index: 20;
  border-radius: 4px 4px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/views/community/communityHome.vue